import * as React from "react";
import { FeedItem } from "../../../server/feed/buildfeed";
import { Compo } from "../models/compos";
import { assertNever } from "../util";
import { FeedElementMention } from "./FeedElementMention";
import { FeedElementComment } from "./FeedElementComment";
import { FeedElementCommentUser } from "./FeedElementCommentUser";
import { FeedElementLike } from "./FeedElementLike";
import { FeedElementCommentLike } from "./FeedElementCommentLike";
import { FeedElementNewEntry } from "./FeedElementNewEntry";
import { FeedElementYourEntry } from "./FeedElementYourEntry";
import { FeedElementReview } from "./FeedElementReview";
import { FeedElementNewUser } from "./FeedElementNewUser";
import { FeedElementNewTag } from "./FeedElementNewTag";
import { FeedElementNewForumTopic } from "./FeedElementNewForumTopic";
import { FeedItemOngoingCompo } from "./FeedItemOngoingCompo";
import { TestIds } from "../testIds";

export const FeedView = ({
  items,
  hideSubmitButton,
}: {
  items: FeedItem[];
  hideSubmitButton?: boolean;
}) => {
  const renderedItems = items.map((feedItem, index) => {
    if (feedItem.type === "mention") {
      return <FeedElementMention item={feedItem} key={index} />;
    }

    if (
      feedItem.type === "comment" ||
      feedItem.type === "comment-on-other-entry" ||
      feedItem.type === "comment-forum"
    ) {
      return <FeedElementComment item={feedItem} key={index} />;
    }

    if (feedItem.type === "comment-user") {
      return <FeedElementCommentUser item={feedItem} key={index} />;
    }

    if (feedItem.type === "like") {
      return <FeedElementLike item={feedItem} key={index} />;
    }

    if (feedItem.type === "comment-like") {
      return <FeedElementCommentLike item={feedItem} key={index} />;
    }

    if (feedItem.type === "new-entry") {
      return <FeedElementNewEntry item={feedItem} key={index} />;
    }

    if (feedItem.type === "your-entry") {
      return <FeedElementYourEntry item={feedItem} key={index} />;
    }

    if (feedItem.type === "review") {
      return <FeedElementReview item={feedItem} key={index} />;
    }

    if (feedItem.type === "new-user") {
      return <FeedElementNewUser item={feedItem} key={index} />;
    }

    if (feedItem.type === "tag") {
      return <FeedElementNewTag item={feedItem} key={index} />;
    }

    if (feedItem.type === "new-forum-topic") {
      return <FeedElementNewForumTopic item={feedItem} key={index} />;
    }

    if (feedItem.type === "upcoming-contest") {
      if (new Compo(feedItem.compo).state === "entry") {
        return (
          <FeedItemOngoingCompo
            item={feedItem}
            key={index}
            hideSubmitButton={hideSubmitButton}
          />
        );
      }
    }

    if (
      feedItem.type === "topofmonth" ||
      feedItem.type === "upcoming-contest" ||
      feedItem.type === "receive-gold" ||
      feedItem.type === "event" ||
      feedItem.type === "stats"
    ) {
      return null;
    }

    assertNever(feedItem);

    return null;
  });

  return <div data-testid={TestIds.FeedContent}>{renderedItems}</div>;
};
